import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useState } from 'react';
const LocationContext = createContext(null);
export function LocationProvider({ children, initialCoords = null }) {
    const [coords, setCoordsState] = useState(initialCoords);
    const setCoords = useCallback((nextCoords) => {
        setCoordsState(nextCoords);
    }, []);
    const setApproximateCoords = useCallback((nextCoords) => {
        setCoordsState((currentCoords) => currentCoords?.origin === 'browser' ? currentCoords : nextCoords);
    }, []);
    return (_jsx(LocationContext.Provider, { value: { coords, setCoords, setApproximateCoords }, children: children }));
}
export function useLocation() {
    const ctx = useContext(LocationContext);
    if (!ctx) {
        throw new Error('useLocation must be used within LocationProvider');
    }
    return ctx;
}
//# sourceMappingURL=LocationProvider.js.map